// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1dhW9","head":"Table_head__3wRsb","col":"Table_col__8tlF3"};